import { SeverityConfig } from '../types/hotspots';

// Konfigurasi warna berdasarkan severity
export const SEVERITY_COLORS: Record<number, string> = {
    4: "#FF0000", // Bahaya - Merah menyala
    3: "#FF8C00", // Waspada - Oranye
    2: "#FFD700", // Perhatian - Kuning
    1: "#00FF00", // Aman - Hijau
};

export const SEVERITY_CONFIGS: SeverityConfig[] = [
    { level: 4, label: "Bahaya", color: "#FF0000", description: "Tingkat bahaya tinggi" },
    { level: 3, label: "Waspada", color: "#FF8C00", description: "Perlu kewaspadaan" },
    { level: 2, label: "Perhatian", color: "#FFD700", description: "Memerlukan perhatian" },
    { level: 1, label: "Aman", color: "#00FF00", description: "Kondisi aman" },
];

export const getSeverityColor = (severity: number): string => {
    return SEVERITY_COLORS[severity] || "#808080"; // Default abu-abu untuk severity tidak dikenal
};

export const getSeverityConfig = (severity: number): SeverityConfig | undefined => {
    return SEVERITY_CONFIGS.find(config => config.level === severity);
};

export const formatDateTime = (dateTimeString: string): { date: string; time: string } => {
    const date = new Date(dateTimeString);
    const dateStr = date.toLocaleDateString('id-ID', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    });
    const timeStr = date.toLocaleTimeString('id-ID', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });

    return { date: dateStr, time: timeStr };
};

export const getTodayDateString = (): string => {
    const today = new Date();
    return today.toISOString().split('T')[0];
};

export const getDateNDaysAgo = (days: number): string => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString().split('T')[0];
};